import React, { forwardRef, useEffect } from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Scan } from 'lucide-react';

const BarcodeInput = forwardRef((
  {
    label,
    value,
    onChange,
    onScan,
    placeholder,
    disabled,
    error,
    className = '',
    autoFocus = false,
    maxLength,
    'data-testid': testId
  },
  ref
) => {
  useEffect(() => {
    if (autoFocus && ref && ref.current) {
      ref.current.focus();
    }
  }, [autoFocus, ref]);

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault(); // Prevent form submission
      if (value && onScan) {
        onScan(value);
      }
    }
  };

  return (
    <div className={`space-y-2 ${className}`}>
      {label && (
        <Label className="text-sm font-medium text-[#1A1F2E]">
          {label}
        </Label>
      )}
      <div className="relative">
        <div className="absolute left-3 top-1/2 -translate-y-1/2 text-[#8A8F9E]">
          <Scan className="w-5 h-5" />
        </div>
        <Input
          ref={ref}
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder={placeholder}
          disabled={disabled}
          maxLength={maxLength}
          data-testid={testId}
          className={`h-12 pl-11 pr-4 font-mono text-lg tracking-wider bg-white border-2 rounded-lg transition-all duration-200 ${
            error
              ? 'border-[#B8374A] ring-2 ring-[#B8374A]/20'
              : 'border-[#E5DFD0] focus:border-[#2D5F4F] focus:ring-2 focus:ring-[#2D5F4F]/20'
          }`}
        />
      </div>
      {error && (
        <p className="text-sm text-[#B8374A] mt-1" data-testid={`${testId}-error`}>
          {error}
        </p>
      )}
    </div>
  );
});

BarcodeInput.displayName = 'BarcodeInput';

export default BarcodeInput;